import { NgModule, ErrorHandler } from '@angular/core';
import * as StackTrace from 'stacktrace-js';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import { HttpErrorResponse } from '@angular/common/http';

class MyErrorHandler implements ErrorHandler {
  public handleError(error: any) {
    // do something with the exception
    console.warn('global exception (' + typeof error + ':' + error.constructor.name + ')', error);
    if (typeof error === 'string') {
      return FirebaseCrashlytics.recordException({
        message: error,
      }).then(() => FirebaseCrashlytics.sendUnsentReports());
    } else if (error instanceof HttpErrorResponse) {
      return FirebaseCrashlytics.recordException({
        message: error.message,
      }).then(() => FirebaseCrashlytics.sendUnsentReports());
    } else {
      StackTrace.fromError(error)
        .then(stacktrace => {
          // console.warn('error', error, 'stack', stacktrace);
          return FirebaseCrashlytics.recordException({
            message: error.message,
            stacktrace: error.stack,
          });
        })
        .catch(() => {
          console.warn('Unparsable', error);
        })
        .then(() => FirebaseCrashlytics.sendUnsentReports());
    }
  }
}

@NgModule({
  providers: [{ provide: ErrorHandler, useClass: MyErrorHandler }],
})
export class CatchModule {}
